/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.0",
  "gitBuildTime": "2026-09-17T17:37:38.799Z",
  "gitBuildVersion": "2.9.0",
  "gitCommitId": "91ca9a6",
  "gitCommitIdFull": "91ca9a64cb3a39750d1b0b76f6aee59822038748",
  "gitCommitTime": "2026-09-17T17:35:33.000Z",
  "version": "2.9.0-2026-09-17T17:35:33.000Z-(91ca9a6)"
};
